import React, {Component} from "react";
const roadMap = () => {
    window.open("https://AVAXs.com/about");
  };
  const home = () => {
    window.open("https://AVAXs.com/")
  };
  const smartContract = () => {
    window.open(
      "https://snowtrace.io/address/0xabd1078632a31c889b4a8d9112b1c1a8499ee951#code"
    );
  };

class Navbar extends Component {
    
   
    render() {
        return (
            <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <div class="container-fluid">
              <a class="navbar-brand" href="#"><img src="https://AVAXs.com/cbLogo.png" alt="" width="200"  class="d-inline-block align-text-top"></img></a>
              <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                <div class="navbar-nav">
                  <a class="nav-link active" aria-current="page" onClick={home}>Home</a>
                  <a class="nav-link" onClick={smartContract}>Go View Contract</a>
                  <a class="nav-link" onClick={roadMap}>Whitepaper</a>              
                </div>
              </div>
            </div>
          </nav>
        )
    }
}



export default Navbar;